module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlave/Nagano_Chlave_MIROC5_RCP26_Now.png";